import {StatusType} from 'constants/flow/flowTypes';
import {CART} from 'constants/actions';
import {clearCartAdd} from 'actions/cart/cart';

export type CartAddType = {
    status: StatusType;
    id?: string; // TODO Mary it is used in analytic, but it is not clear what is diff between this and item_id
    item_id?: string; // it is also used in getAddedQuoteItem, probably, one from addToCart, another - from updateCart
    error?: {message: string};
};

export const initialState = {status: null};

/**
 * Add to cart request
 *
 * @param {CartAddType} state Current state
 * @param {Object} action Received action
 * @returns {CartAddType} item id if successful, error message otherwise
 */
export default function cartAdd(
    state: CartAddType = initialState,
    action: {type: string; payload?: any},
): CartAddType {
    switch (action.type) {
        case `${CART.ADD_TO_CART}_FULFILLED`:
        case `${CART.UPDATE_CART}_FULFILLED`:
            return {...action.payload.data, status: 'fulfilled'};
        case `${CART.UPDATE_CART}_PENDING`:
        case `${CART.ADD_TO_CART}_PENDING`:
            return {status: 'pending'};
        case `${CART.UPDATE_CART}_REJECTED`:
            return {status: 'rejected'};
        case `${CART.ADD_TO_CART}_REJECTED`:
            return {...action.payload.response.data, status: 'rejected'};
        case `${clearCartAdd}`:
            return initialState;
        default:
            return state;
    }
}
